import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { WorkflowService} from './workflow.service';

import { FormData, Payment } from './payment.model';
import { STEPS } from './workflow.model';

import { BehaviorSubject } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable()
export class PaymentService {
    apiUrl: string;

    private formData: FormData = new FormData();
    private isCardFormValid = false;
    private isPlanFormValid = false;
    private planDataSource = new BehaviorSubject({});
    private taxDataSource = new BehaviorSubject({});

    planDataSubscription = this.planDataSource.asObservable();

    paymentData = [];

    constructor(public workFlowService: WorkflowService, private http: HttpClient) {
      this.apiUrl = environment.apiUrl;
    }

    getCardData(): Payment {
        // Return the Payment data
        const paymentData: Payment = {
            cardNumber: this.formData.cardNumber,
            ccvCode: this.formData.ccvCode,
            expiryDate: this.formData.expiryDate,
            nameOnCard: this.formData.nameOnCard,
            paymentToken: this.formData.paymentToken,
            registerToken: this.formData.registerToken
        };
        return paymentData;
    }

    invalidateStepPayment() {
        this.workFlowService.invalidateStep(STEPS.plan);
    }

    setCardData(data: Payment) {
        // Update the Payment data only when the Payment Form had been validated successfully
        this.isCardFormValid = true;
        this.formData.cardNumber = data.cardNumber;
        this.formData.ccvCode = data.ccvCode;
        this.formData.expiryDate = data.expiryDate;
        this.formData.nameOnCard = data.nameOnCard;
        this.formData.paymentToken = data.paymentToken;
        this.formData.registerToken = data.registerToken;
        // Validate Personal payment in Workflow
        this.workFlowService.validateStep(STEPS.card);
    }

    // Plan first step

    setPackageId(data) {
      this.formData.packageId = data;
    }

    getPackageId() {
      return this.formData.packageId;
    }

    setCameraPlan(data) {
      this.formData.planId = data;
    }

    getCameraPlan() {
        // Return Selected cameraPlan
        return this.formData.planId;
    }

    submitPlanSteps() {
        // Update the work type only when the Work Form had been validated successfully
        this.isPlanFormValid = true;
        // Validate Work token in Workflow
        this.workFlowService.validateStep(STEPS.plan);
    }

    // Plan first step

    getFormData(): FormData {
        // Return the entire Form Data
        return this.formData;
    }

    resetFormData(): FormData {
        // Reset the workflow
        this.workFlowService.resetSteps();
        // Return the form data after all this.* members had been reset
        this.formData.clear();
        this.isCardFormValid = this.isPlanFormValid = false;
        return this.formData;
    }

    isFormValid() {
        // Return true if all forms had been validated successfully; otherwise, return false
        return this.isCardFormValid && this.isPlanFormValid;
    }

    setCardPlan(data) {
      this.planDataSource.next(data);
    }

    setTaxPercentage(tax) {
      this.taxDataSource.next(tax);
    }

    renewSubscription(accessToken, data) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: accessToken
      });
      return this.http.post(`${this.apiUrl}/payment/renew`, data, { headers });
    }

    downloadPdf(id, accessToken) {
      let headers = new HttpHeaders();
      headers = headers.set('Accept', 'application/pdf');
      headers = headers.set('Authorization', accessToken);
      return this.http.get(`${this.apiUrl}/invoice/${id}/pdf`, { headers, responseType: 'blob' });
    }

}
